import React from 'react';

import Button from '../../../library/button/button';
import Typography from '../../../library/typography/typography';
import MessageDotsSolidIcon from '../../../shared/icons/message-dots-solid-icon';

import useThirdPartyChat from '../../../shared/hooks/use-third-party-chat/use-third-party-chat';

import {
  LIVE_PERSON_CHAT_BUTTON_IDS,
  THIRD_PARTY_CHAT_BUTTON_IDS
} from '../../../shared/constants/third-party-chat';

import styles from './cec-contact-us-chat-button.scss';

function CecContactUsChatButton() {
  const { isLoading: isThirdPartyChatLoading, launchChat } = useThirdPartyChat({
    chatButtonId:
      process.env.__FF_SALESFORCE_CHAT__ === 'true'
        ? THIRD_PARTY_CHAT_BUTTON_IDS.CEC_CONTACT_US
        : undefined
  });

  return (
    <span className={styles['container']}>
      {process.env.__FF_SALESFORCE_CHAT__ !== 'true' && (
        <div
          className={styles['lp-button']}
          data-testid={LIVE_PERSON_CHAT_BUTTON_IDS.CEC_CONTACT_US}
          id={LIVE_PERSON_CHAT_BUTTON_IDS.CEC_CONTACT_US}
        />
      )}
      {!isThirdPartyChatLoading && (
        <>
          <span className={styles['text-before-button']}>or</span>
          <Button
            className={styles['button']}
            data-testid="cec-contact-us-chat-button__button"
            onClick={launchChat}
          >
            <MessageDotsSolidIcon className={styles['icon']} />
            <Typography className={styles['text']} tag="span">
              Chat
            </Typography>
          </Button>
        </>
      )}
    </span>
  );
}

export default CecContactUsChatButton;
